import FileIcon from '@components/icons/File.svg';
import { cn } from '@helpers/cn';
import { splitFileNameForMiddleTruncation } from '@helpers/splitFileNameForMiddleTruncation';
import { TProps } from './types/TProps';

export const ExternalFileDownloadLink = ({ href, label, className, testId }: TProps) => {
  const { head, tail } = splitFileNameForMiddleTruncation(label);

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      download={label}
      title={label}
      data-testid={testId}
      className={cn('btn--file-link inline-flex min-w-0 items-center underline !text-[13px] !font-medium', className)}
    >
      <FileIcon aria-hidden="true" className="shrink-0" />
      <span className="flex min-w-0 flex-1">
        <span className="truncate">{head}</span>
        {tail ? <span className="shrink-0">{tail}</span> : null}
      </span>
    </a>
  );
};
